!function($) {

  // Add custom JavasScript here
  // --------------------------

  // Document ready
  $(function() {
  
     $('#in_stock').click(function(){
        if($(this).prop("checked") == true){
           $(".sbb, .disabled").closest("article").hide()
        }
        else if($(this).prop("checked") == false){
            $(".sbb, .disabled").closest("article").show()
        }
    });
  });

}(jQuery);